import { CorporatePositionDto } from './../../models/position/corporate-position.dto';
export const corporatePositionsMock: CorporatePositionDto[] = [
  {
    id: 'a1c3d2e4-5f67-4a89-9b01-2c3d4e5f6a70',
    corporationId: '0c2f6a2b-9d5e-4d1f-a7d2-3f4e5a6b7c8d',
    title: 'Operations Manager',
    description: 'Oversees day-to-day operations across corporate locations.',
    department: 'Operations',
    level: 7,
    isActive: true,
    isDefault: false,
    createdAt: '2024-03-05T15:20:00Z',
    updatedAt: '2025-01-18T10:05:00Z'
  },
  {
    id: 'b2d4e5f6-7081-4b92-8c03-4d5e6f708192',
    corporationId: '0c2f6a2b-9d5e-4d1f-a7d2-3f4e5a6b7c8d',
    title: 'HR Coordinator',
    description: null,
    department: 'Human Resources',
    level: 4,
    isActive: true,
    isDefault: true,
    createdAt: '2023-08-12T12:00:00Z',
    updatedAt: null
  }
];
